import "./Contact.css";
import React from "react";
import { assets } from "../../assets/assets";
import Navbar from "../Navbar/Navbar";

function Contact() {
  const iframeSrc =
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3460.089025817328!2d75.9438716!3d30.8749655!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a9d758784a215%3A0x1fbf93282bba3718!2sB.P%20Alloys%20Limited!5e1!3m2!1sen!2sin!4v1757784151460!5m2!1sen!2sin";
  const iframeStyle = { border: "0" };
  return (
    <>
      <div className="contact">
        <Navbar />
        <div className="overlayc"></div>
        <div className="content">
          <div className="buttonone">CONTACT&nbsp;US</div>
          <div className="head textgradient">
            Get&nbsp;in&nbsp;touch&nbsp;with&nbsp;us&nbsp;!
          </div>
          <div className="contactinfo">
            <a href="tel:01612972640" className="phoneone">
              <i className="fa-solid fa-phone"></i>
              <div className="name">PHONE</div>
              Ph.&nbsp;:&nbsp;0161-2972640
            </a>
            <div className="linetwo"></div>
            <a
              href="https://maps.app.goo.gl/sgwn1tqHHQVTX8rd7"
              className="phonetwo"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-solid fa-map-location-dot"></i>
              <div className="name">ADDRESS</div>
              Regd.&nbsp;Office&nbsp;&&nbsp;Works:&nbsp;B-52/D-252,
              Phase&nbsp;VII, Focal Point, 141010,
              Ludhiana,&nbsp;Punjab,&nbsp;India.
            </a>
            <div className="linetwo"></div>
            <a href="mailto:info@bpalloys.co.in" className="phonethree">
              <i className="fa-solid fa-envelope-open-text"></i>
              <div className="name">EMAIL</div>
              info@bpalloys.co.in
            </a>
          </div>
          <a
            href="https://www.linkedin.com/company/bp-alloys-limited/"
            className="linkedin"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-linkedin textgradient"></i>
            LinkedIn
          </a>
          <div>
            <iframe
              className="map"
              src={iframeSrc}
              style={iframeStyle}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
